<template>
  <v-container pa-0 style="width: 100%;">
    <ServiceItem v-for="service in services" :key="service.id" :service="service" />
    <v-container v-if="services.length == 0">
      <p>
        <v-icon color="info" class="pr-2" style="line-height: 19px;">error_outline</v-icon>
        This place is empty. Register a service and it will show up here!
      </p>
    </v-container>
  </v-container>
</template>

<script>
  import ServiceItem from '../ServiceItem'
  export default {
    components: {
      ServiceItem,
    },
    props: {
      services: Array,
    },
    mounted() {
      this.$emit('load', false)
    },
  }
</script>